import './table.css';
import { useEffect, useState } from 'react';

export default function Table2() {
  // Define color options with descriptions
  const colorOptions = [
    { color: '#C1B7E3', description: 'Calm and positive' },
    { color: '#88D4A4', description: 'Energized and confident' },
    { color: '#5E3A85', description: 'Reflective and introspective' },
    { color: '#B3D9FF', description: 'Anxious or overwhelmed' },
    { color: '#FFE5B4', description: 'Friendly and easy-going' },
    { color: '#FFD1DC', description: 'Lonely or isolated' },
    { color: '#D3E4CD', description: 'Neutral and steady' },
    { color: '#FFFFFF', description: 'Delete this entry' },
  ];

  // Add unique identifier for table2
  const [tableColors, setTableColors] = useState(
    () =>
      JSON.parse(localStorage.getItem('tableColors2')) || // Changed key name
      Array.from({ length: 31 }, () => Array(12).fill(null)),
  );

  // State to track the currently selected color
  const [selectedColor, setSelectedColor] = useState(
    () => localStorage.getItem('selectedColor2') || null, // Changed key name
  );

  useEffect(() => {
    localStorage.setItem('tableColors2', JSON.stringify(tableColors)); // Changed key name
  }, [tableColors]);

  useEffect(() => {
    localStorage.setItem('selectedColor2', selectedColor); // Changed key name
  }, [selectedColor]);

  // Handle color change for a specific cell
  const handleColorChange = (rowIndex, colIndex) => {
    if (!selectedColor) return; // Do nothing if no color is selected
    const newTableColors = [...tableColors];
    newTableColors[rowIndex][colIndex] = selectedColor;
    setTableColors(newTableColors);
  };

  return (
    <div>
      <div className="header-rate-day">
        <h1>Rate My Social</h1>
        <ol>
          <li>Pick a color from the options below</li>
          <li>Click on a cell to color your day</li>
          <li>See you again tomorrow </li>
        </ol>
      </div>
      <div className="table-container">
        {/* Table */}
        <table>
          <thead>
            <tr>
              <th>Day</th>
              {['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'].map(
                (month, index) => (
                  <th key={index}>{month}</th>
                ),
              )}
            </tr>
          </thead>
          <tbody>
            {tableColors.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{rowIndex + 1}</td>
                {row.map((color, colIndex) => (
                  <td
                    key={colIndex}
                    onClick={() => handleColorChange(rowIndex, colIndex)}
                    style={{ backgroundColor: color }}
                  ></td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        {/* Color Picker */}
        <div className="color-picker-container">
          <div className="color-picker">
            <h4>Select your mood</h4>
            {colorOptions.map(({ color, description }, index) => (
              <div
                key={index}
                onClick={() => {
                  console.log(`Color selected: ${color}`);
                  setSelectedColor(color);
                }}
              >
                <div
                  className={`color-box ${
                    selectedColor === color ? 'selected' : ''
                  }`}
                  style={{ backgroundColor: color }}
                ></div>
                <span className="color-picker-description">{description}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
